var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"icon-container",style:(_vm.cssVars),on:{"click":_vm.onClick}},[_c('svg',{class:("icons-" + _vm.name)},[_c('use',{attrs:{"href":_vm.iconId}})])])}
var staticRenderFns = []

export { render, staticRenderFns }